import React, { useState, useRef } from 'react'
import { Accordion, Button, Container, Form, FormControl, InputGroup, Nav, Row, Col, Tab, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { data } from '../data';
import styles from './Archives.module.scss';
import { useHistory, useParams, useLocation } from 'react-router-dom'

const ArchivesNews = () => {

    return (<>

        <Container className='outerContainer'>
            <h1 className="centerText mb-4">News Archives</h1>
        </Container>

        <Container className='outerContainer'>
            <Tab.Container id="left-tabs-example" defaultActiveKey="2016">
                <Row>
                    <Col sm={3}>
                        <Nav variant="pills" className="flex-column">
                            <Nav.Item>
                                <Nav.Link eventKey="2016">2016</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2015">2015</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2013">2013</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2012">2012</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2011">2011</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2010">2010</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2009">2009</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2008">2008</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2007">2007</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2006">2006</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2005">2005</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2004">2004</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2003">2003</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link eventKey="2002">2002</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link href="https://www.qualityindicators.ahrq.gov/Downloads/Resources/Publications/2008/AHRQ%20QI%20Validation%20Pilot%20Phase%20II_Interest%20Form_Final.pdf">AHRQ QI Validation Pilot Phase II Interest Form</Nav.Link>
                            </Nav.Item>
                            <hr className="divider-blue"/>
                            <Nav.Item>
                                <Nav.Link href="https://www.qualityindicators.ahrq.gov/Downloads/News/Comparative_Reporting_Insert_QI_Tech.pdf">AHRQ Summary Statement on Comparative Hospital Public Reporting (Dec 2005)</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Col>
                    <Col sm={9}>
                        <Tab.Content>
                            <Tab.Pane eventKey="2016">
                                <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2016").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/>  
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2016").map((info) => (<>
                                    <h6 id={info.id}  className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}
                            </Tab.Pane>
                            <Tab.Pane eventKey="2015">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2015").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/>  
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2015").map((info) => (<>
                                    <h6 id={info.id}  className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}

                            </Tab.Pane>
                            <Tab.Pane eventKey="2013">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2013").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/> 
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2013").map((info) => (<>
                                    <h6 id={info.id}  className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}

                            </Tab.Pane>
                            <Tab.Pane eventKey="2012">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2012").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/> 
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2012").map((info) => (<>
                                    <h6 id={info.id} className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}

                            </Tab.Pane>
                            <Tab.Pane eventKey="2011">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2011").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/> 
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2011").map((info) => (<>
                                    <h6 id={info.id}  className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}

                            </Tab.Pane>
                            <Tab.Pane eventKey="2010">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2010").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/>  
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2010").map((info) => (<>
                                    <h6 id={info.id} className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}

                            </Tab.Pane>
                            <Tab.Pane eventKey="2009">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2009").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/> 
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2009").map((info) => (<>
                                    <h6 id={info.id}  className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}

                            </Tab.Pane>
                            <Tab.Pane eventKey="2008">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2008").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/> 
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2008").map((info) => (<>
                                    <h6  id={info.id} className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}
                            </Tab.Pane>
                            <Tab.Pane eventKey="2007">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2007").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/> 
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2007").map((info) => (<>
                                    <h6 id={info.id}  className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}
                            </Tab.Pane>
                            <Tab.Pane eventKey="2006">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2006").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/> 
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2006").map((info) => (<>
                                    <h6 id={info.id}  className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}
                            </Tab.Pane>
                            <Tab.Pane eventKey="2005">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2005").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/> 
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2005").map((info) => (<>
                                    <h6  id={info.id} className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}
                            </Tab.Pane>
                            <Tab.Pane eventKey="2004">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2004").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/> 
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2004").map((info) => (<>
                                    <h6 id={info.id}  className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}
                            </Tab.Pane>
                            <Tab.Pane eventKey="2003">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2003").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/> 
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2003").map((info) => (<>
                                    <h6 id={info.id}  className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}
                            </Tab.Pane>
                            <Tab.Pane eventKey="2002">
                            <ul>
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2002").map((info) => (<>
                                    <li><p className="subtitle mb-0 mt-1"><a href={"#" + info.id} >{info.date} - <div style={{display: 'inline'}} dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></p></li>
                                </>)
                                )}
                                </ul>
                             <hr/> 
                            {data.NewsArchive && data.NewsArchive.filter((info) => info.category == "2002").map((info) => (<>
                                    <h6 id={info.id}  className="mb-0 mt-1">{info.date}</h6>
                                    <h4><a href={info.url ? info.url : null}><div dangerouslySetInnerHTML={{ __html: info.title }} className="mt-3 mb-3" /></a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: info.desc }} className="mt-1 mb-3" />
                                    <hr />
                                </>)
                                )}
                            </Tab.Pane>
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </Container>
    </>)
}


export default ArchivesNews;